import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableProviderInvoicesComponent from '../components/TableProviderInvoicesComponent';
import { validateSession } from '../utils/functions';

// ENI-32 — Facturas de proveedor (cuentas por pagar). Es el lugar donde vive el estado de pago
// de lo que se le debe a cada proveedor; las reposiciones lo heredan de la factura que las cubre.
class ProviderInvoicesPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
        };
    }

    async componentDidMount() {
        let role = await validateSession(true);
        this.setState({ checked: true, role: role });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={36} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Proveedores" subtitle="Facturas a pagar" />
                            <TableProviderInvoicesComponent role={this.state.role} />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default ProviderInvoicesPage;
